<template>
    <el-popover placement="bottom" trigger="hover">
        <div class="list-panel">
            <div
                v-for="(item, index) in serviceArr"
                :key="index"
                class="list-item"
                @click="itemClick(item)"
            >
                {{ item.name }}
            </div>
        </div>
        <!-- {{ $t('home_service_modal_tips') }} -->
        <span slot="reference">
            <slot />
        </span>
    </el-popover>
</template>

<script>
import { mapState } from 'vuex';
import { isHttpUrl, openLinkInHiddenWindow } from '@/utils';

export default {
    name: 'CtServicePopup',
    data() {
        return {
            openLinkInHiddenWindow
        };
    },
    computed: {
        ...mapState({
            userInfo: state => state.user.user_info
        }),
        serviceArr() {
            const { service_link } = this.userInfo;
            const defaultArr = [
                {
                    name: `${this.$t('customer_service')}`,
                    service_link: ''
                }
            ];

            if (!service_link) return defaultArr;

            const arr = service_link.split(',');
            const result = arr.map((e, index) => {
                const num = index + 1;
                return {
                    name: `${this.$t('customer_service')} ${num}`,
                    service_link: e
                };
            });
            return result;
        }
    },
    mounted() {},
    methods: {
        closeHandle() {
            this.$emit('update:show', false);
        },
        itemClick(item) {
            const { service_link } = item;
            // const isComplete = isHttpUrl(service_link);
            // if (!service_link || !isComplete) {
            //     // uni.$u.toast(this.$t('tv_fingerprint_recognition_exception'));
            //     return;
            // }

            this.closeHandle();
            // location.href = service_link;
            // window.open(service_link, '_blank');
            this.openLinkInHiddenWindow(service_link);
        }
    }
};
</script>

<style lang="scss" scoped>
.service-popup {
    background-color: var(--bg-color-thin);
    padding: 0 12px 10px 12px;
}
.list-panel {
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid var(--text-color-deep);
}
.list-item {
    padding: 14px 0;
    text-align: center;
    color: var(--text-color-base);
    font-size: 16px;
    cursor: pointer;
    &:hover {
        color: $basicColor;
    }
}
</style>
